import { css } from '@emotion/react';
import { mediaQuery } from '@presentation/styles';
import { MAP_BREAKPOINT } from '../../styled';

export const HeaderChildrenWrapperStyled = (props: { hasMap: boolean }) => css`
  ${mediaQuery(MAP_BREAKPOINT, 'min')} {
    ${props.hasMap && 'margin-right: 30vw; padding-right: 25px;'};
  }
`;
